/**
 * `tel:`-Adresse aus einer Nummer, wie sie in CRM oder PM steht: „0351 000 001“
 * wird `tel:0351000001`, „+49 (0) 351 000“ wird `tel:+49351000`. Übrig bleiben
 * Ziffern und ein führendes Plus; die „(0)“ hinter der Landesvorwahl fällt weg,
 * sonst wählt das Telefon sie mit.
 */
export function telHref(nummer: string): string {
  const ohneNull = nummer.replace(/\(\s*0\s*\)/g, '');
  const plus = ohneNull.trim().startsWith('+') ? '+' : '';
  return `tel:${plus}${ohneNull.replace(/\D/g, '')}`;
}
